import axios from 'axios'
import { getAuthHeaders } from './apiConfig'

const http = axios

export interface StartupInfos {
  collectivite: any
  periodes: Periode[]
}

export interface Periode {
  month: number
  year: number
  label: string
  value: string
  selected: boolean
}

export interface WalletInfos {
  total_montant_decaissements: number
  last_montant_decaissement: number
  total_montant_prelevements: number
  solde: number
}

export interface PrelevementsInfos {
  prelevements: PrelevementItem[]
  montant_prelevement_expected: number
}

export interface PrelevementItem {
  id: number
  periode_prelevement: string
  periode_prelevement_formatted: string
  montant_prelevement: number
  montant_prelevement_expected: number
  status_prelevement: string
  status_prelevement_label: string
  fichier_prelevement: string | null
  created_at: string
  created_at_formatted: string
}

export interface DecaissementInfos {
  users: DecaissementUser[]
  montant_decaissement: number
  montant_prelevement: number
  montant_prelevement_expected: number
  solde: number
}

export interface DecaissementUser {
  id: number
  nom: string
  prenom: string
  avatar: string | null
  photo: string | null
  collectivite_id: number
  collectivite_nom: string
  souscription_id: number | null
  souscription_pouvoir_achat: number | null
  souscription_statut: string | null
  souscription_date_prevision_formatted: string | null
  souscription_created_at_formatted: string | null
  prelevement_id: number | null
  prelevement_montant_prelevement: number | null
  prelevement_status_prelevement: string | null
  prelevement_periode_prelevement_formatted: string | null
  prelevement_created_at_formatted: string | null
  status_prelevement_label: string | null
  decaissement_id: number | null
  decaissement_montant_decaissement: number | null
}

class PrelevementService {
  async getStartupInfos(): Promise<StartupInfos> {
    try {
      const response = await http.get('/collectivites/prelevements/startup_infos', {
        headers: getAuthHeaders()
      })
      return response.data
    } catch (error: any) {
      throw new Error(error.response?.data?.error || error.message)
    }
  }

  async getWalletInfos(): Promise<WalletInfos> {
    try {
      const response = await http.get('/collectivites/prelevements/wallet_infos', {
        headers: getAuthHeaders()
      })
      return response.data
    } catch (error: any) {
      throw new Error(error.response?.data?.error || error.message)
    }
  }

  async getPrelevementsInfos(periode: string): Promise<PrelevementsInfos> {
    try {
      const response = await http.get(`/collectivites/prelevements/prelevements_infos?periode=${periode}`, {
        headers: getAuthHeaders()
      })
      return response.data
    } catch (error: any) {
      throw new Error(error.response?.data?.error || error.message)
    }
  }

  async getDecaissementInfos(periode: string): Promise<DecaissementInfos> {
    try {
      const response = await http.get(`/collectivites/prelevements/decaissement_infos?periode=${periode}`, {
        headers: getAuthHeaders()
      })
      return response.data
    } catch (error: any) {
      throw new Error(error.response?.data?.error || error.message)
    }
  }

  async savePrelevement(data: { periode_prelevement: string; montant_prelevement: number; fichier_prelevement: File | null }): Promise<any> {
    try {
      const formData = new FormData()
      formData.append('periode_prelevement', data.periode_prelevement)
      formData.append('montant_prelevement', data.montant_prelevement.toString())
      if (data.fichier_prelevement) {
        formData.append('fichier_prelevement', data.fichier_prelevement, data.fichier_prelevement.name)
      }

      const response = await http.post('/collectivites/prelevements/save', formData, {
        headers: {
          ...getAuthHeaders(),
          'Content-Type': 'multipart/form-data'
        }
      })
      return response.data
    } catch (error: any) {
      throw new Error(error.response?.data?.error || error.message)
    }
  }

}

export default new PrelevementService()
